import React from 'react'
import { User } from '../../../api/users'
import { Organization } from '../../../api/organizations'
import Modal from '../../modal'
import { useModal } from '../../modal'
import BulkContractualSchedulesForm from '../forms/bulk-contractual-schedules-form'

interface BulkContractualSchedulesModalProps {
  users: User[]
  organization: Organization
  modalActions: ReturnType<typeof useModal>
  onSuccess?: () => void
}

/**
 * Modal for applying contractual schedules to multiple workers
 */
const BulkContractualSchedulesModal: React.FC<BulkContractualSchedulesModalProps> = ({
  users,
  organization,
  modalActions,
  onSuccess,
}) => {
  const handleSuccess = () => {
    if (onSuccess) {
      onSuccess()
    }
    modalActions.setIsDisplayed(false)
  }

  return (
    <Modal title="Modifier les horaires contractuels" actions={modalActions} maxWidth={1200}>
      <BulkContractualSchedulesForm
        users={users}
        organization={organization}
        onSuccess={handleSuccess}
      />
    </Modal>
  )
}

export default BulkContractualSchedulesModal
